import {PASTE_COMMAND, COMMAND_PRIORITY_LOW} from 'lexical';
import {useLexicalComposerContext} from '@lexical/react/LexicalComposerContext';
import {useEffect} from 'react';
import {readFileAsDataURL} from '../../../../../utils/readerFileAsDataURL';
import {INSERT_IMAGE_COMMAND} from '../../../../../../../components/LexicalEditor/plugins/ImagesPlugin/commands';
import {checkImageSize} from '../../../../../../../components/LexicalEditor/utils/checkHtmlSize';

interface customPastePluginProps {
    isValidImageType?: (fileName: string) => boolean;
}
export const CustomPastePlugin = (props: customPastePluginProps) => {
    const {isValidImageType} = props;
    const [editor] = useLexicalComposerContext();

    useEffect(() => {
        return editor.registerCommand(
            PASTE_COMMAND,
            event => {
                if (event instanceof ClipboardEvent) {
                    const {clipboardData} = event;
                    if (clipboardData) {
                        const items = clipboardData.items;
                        for (let i = 0; i < items.length; i++) {
                            const item = items[i];
                            if (item.kind === 'file' && item.type.startsWith('image/')) {
                                const file = item.getAsFile();
                                if (file) {
                                    handlePastedImage(file);
                                    return true;
                                }
                            }
                        }
                    }
                }

                return false;
            },
            COMMAND_PRIORITY_LOW
        );
    }, [editor]);

    const handlePastedImage = async (file: File) => {
        try {
            const src = await readFileAsDataURL(file);
            const isBiggerThanMaxSize = checkImageSize(
                src,
                file.name?.split?.('.')?.[0] ?? '',
                file.size
            );
            const isValidType = isValidImageType ? isValidImageType(file.name) : true;
            if (!isBiggerThanMaxSize && isValidType) {
                editor.dispatchCommand(INSERT_IMAGE_COMMAND, {
                    src,
                    altText: file.name?.split?.('.')?.[0] ?? '',
                    isDraggable: false
                });
            }
        } catch (error) {
            console.error('Error reading file:', error);
        }
    };

    return null;
};
